module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "prompt-check-alternatives"
  }, [_c('div', {
    staticClass: "prompt-check-alternatives__header"
  }, [_c('svg', [_c('circle', {
    attrs: {
      "id": "Oval",
      "fill": "#D52727",
      "fill-rule": "evenodd",
      "cx": "13.5",
      "cy": "13.5",
      "r": "13.5"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5,9.5 L9.01471863,17.9852814",
      "id": "Line-4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M17.5,9.5 L9.01471863,17.9852814",
      "id": "Line-4",
      "stroke": "#FFFFFF",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "transform": "translate(13.257359, 13.742641) scale(-1, 1) translate(-13.257359, -13.742641) "
    }
  })]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), (_vm.message) ? _c('p', [_vm._v("\n        " + _vm._s(_vm.message) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "prompt-check-alternatives__buttons"
  }, [(_vm.shouldShowCloseButton) ? _c('button', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.close()
      }
    }
  }, [_vm._v(_vm._s(_vm.closeButtonText))]) : _vm._e(), _vm._v(" "), (_vm.shouldShowActionButton) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.action
    }
  }, [_vm._v(_vm._s(_vm.buttonText))]) : _vm._e(), _vm._v(" "), (_vm.shouldShowTertiaryButton) ? _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.tertiaryAction
    }
  }, [_vm._v(_vm._s(_vm.tertiaryButtonText))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a34541d2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup.vue
// module id = 613
// module chunks = 0